import { useSelector } from "react-redux";
import DynamicTable from "../../../../../utils/Table/DynamicTable";
import { postAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useState } from "react";
import Loading from "../../../../../utils/Loader";
import { Edit } from "@mui/icons-material";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    id: "name",
    label: "FORUM TITLE",
    width: "200px",
  },

  { id: "createdDate", label: "CREATED", width: "200px" },
  { id: "updatedDate", label: "LAST MODIFIED", width: "200px" },
  { id: "status", label: "STATUS", width: "200px" },
  { id: "actions", width: "80px" },
];
const ForumTable = ({ searchText, loading }) => {
  const { forumlist } = useSelector((store) => store.forumBuilder);
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();

  const handleRowOrder = async (newRows) => {
    setReload(true);
    try {
      const pageIds = newRows.map((item) => item.id);
      const result = { pageIds };

      await postAPI(`${BASE_URL}/forum/update-sort-order`, result);
    } catch (e) {
      console.log(e);
    } finally {
      setReload(false);
    }
  };

  const handleNavigate = (row) => {
    navigate(`/admin/forum/${row?.id}`);
  };
  const renderActions = (row) => {
    return (
      <Icon
        className="$color-icon-default"
        icon="edit"
        size="medium"
        style={{ color: "#005CBC" }}
        data-testid="icon"
        onClick={() => handleNavigate(row)}
      />
    );
  };
  return (
    <>
      {reload && <Loading />}
      <DynamicTable
        rows={forumlist}
        columns={columns}
        searchText={searchText}
        onRowClick={(row) => {
          // toggleRowExpansion(row.id);
        }}
        onRowOrderChange={(newOrder) => {
          handleRowOrder(newOrder);
        }}
        pagination={false}
        enableDragAndDrop={true}
        loading={loading}
        renderActions={renderActions}
      />
    </>
  );
};

export default ForumTable;
